import {
  sessionStorageGetItem,
  sessionStorageSetItem,
} from '$func/session-storage'

const KEY = 'urlToLoadAfterLogin'

export const urlToLoadAfterLoginStorage = {
  set(url: string) {
    sessionStorageSetItem(KEY, url)
  },
  get() {
    return sessionStorageGetItem(KEY)
  },
  remove() {
    sessionStorage.removeItem(KEY)
  },
}
